import * as React from 'react'
import { echarts, type EChartOption } from '../echarts'

export type { EChartOption }

export type EChartProps = {
    option: EChartOption
    height?: number
    /** Descrição para leitores de tela; o gráfico em canvas não tem texto. */
    ariaLabel: string
}

/** Um gráfico ECharts que acompanha a largura do card e é descartado ao sair da tela. */
export function EChart({ option, height = 260, ariaLabel }: EChartProps) {
    const ref = React.useRef<HTMLDivElement>(null)
    const chart = React.useRef<echarts.ECharts>()

    React.useEffect(() => {
        if (!ref.current) return
        const instancia = echarts.init(ref.current, undefined, { renderer: 'canvas' })
        chart.current = instancia
        const observer = new ResizeObserver(() => instancia.resize())
        observer.observe(ref.current)
        return () => {
            observer.disconnect()
            instancia.dispose()
            chart.current = undefined
        }
    }, [])

    React.useEffect(() => {
        chart.current?.setOption(option, { notMerge: true })
    }, [option])

    return <div ref={ref} role="img" aria-label={ariaLabel} style={{ width: '100%', height }} />
}

export default EChart
